<template>
    <section class="testimonial-wrapper pb-80px position-relative overflow-hidden">
        <img class="img-shape1 position-absolute" :src="require('@/assets/images/team-1.png')" alt="Testimonial">
        <img class="img-shape2 position-absolute" :src="require('@/assets/images/team-2.png')" alt="Testimonial">
        <img class="img-shape3 position-absolute" :src="require('@/assets/images/team-3.png')" alt="Testimonial">
        <img class="img-shape4 position-absolute" :src="require('@/assets/images/team-4.png')" alt="Testimonial">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1 class="section-title text-center mb-30px">
                        {{dlabData.testimonialData.title}}
                    </h1>
                </div>
            </div>

            <testimonial-slider :items="dlabData.testimonialData.items" />
        </div>
    </section>
</template>


<script>
import dlabData from '@/store/store';
import TestimonialSlider from '../pieces/TestimonialSlider.vue'
export default {
    name: 'TestimonialSection',
    components: {
        TestimonialSlider
    },
    data() {
        return {
            dlabData
        }
    }
}
</script>